import { lazy } from "react";

const list = lazy(() => import("./List").then(m => ({ default: m.InvestmentList })));
const edit = lazy(() => import("./Edit").then(m => ({ default: m.InvestmentEdit })));
const create = lazy(() => import("./Create").then(m => ({ default: m.InvestmentCreate })));

export default { list, edit, create };
